define('responsive-gameday-calendar/src/js/GamedayCalendar',['require','exports','module','jquery','es6ish-class/es6ish-class','requirejs-hogan-plugin/hogan','pikaday/pikaday','moment','message-service/message-service','gameday-index-enums/enums/events/LoadEvents','text!../templates/gd_calendar.tpl','gameday-index-url-hasher/UrlHasher','gid-decoder/GidDecoder'],function (require, module, exports) {

    var $ = require('jquery'),
        es6ishClass = require('es6ish-class/es6ish-class'),
        hogan = require('requirejs-hogan-plugin/hogan'),
        pickadate = require('pikaday/pikaday'),
        moment = require('moment'),
        dispatcher = require("message-service/message-service"),
        LoadEvts = require("gameday-index-enums/enums/events/LoadEvents"),
        calendarTemplate = hogan.compile(require('text!../templates/gd_calendar.tpl')),
        UrlHash = require("gameday-index-url-hasher/UrlHasher"),
		GID = require("gid-decoder/GidDecoder");

    var GamedayCalendar = es6ishClass(function(selectorString) {
        var that = this;
        // Set where on the page this is going on Scoreboard instance creation
        this.targetDivSelector = selectorString;

        $(this.targetDivSelector).on('click', '.left', function(){
            that.updateDate(moment(that.currentDate).subtract(1, 'days'));
        });

        $(this.targetDivSelector).on('click', '.right', function(){
            that.updateDate(moment(that.currentDate).add(1, 'days'));
        });

        dispatcher.addListener.call(this, LoadEvts.dateChanged, function(date) {
            this.createPiker(); // re-create piker after dom update
        });

        dispatcher.addListener.call(this, LoadEvts.updateCalendar, function(game) {
            that.renderNewDate(moment(game.game_date));
        });
    });

    GamedayCalendar.define({
        /**
         * Where are we placing this component?
         */
        targetDivSelector: "",
        /**
         * What format are we showing the date?
         */
        dateFormatString: "ddd, MMM D",
        /**
         * Current date on screen as a Moment.js object
         */
        currentDate: null,
        /**
         * Instance of datepicker
         */
        pickerInstance: null,
        /**
         * Start up a date picker with desired date
         */
        load: function (config) {
            var gameIDInHashExists = UrlHash.getHashParams().game;
            var gid = gameIDInHashExists ? GID.decodeGID(UrlHash.getHashParams().game) : {
                gameDateString: moment().format('MM/DD/YYYY')
            };     

            this.updateDate(gid.gameDateString);
        },
        /**
         * Date was changed, update screen and alert the scoreboard
         */
        updateDate: function(date) {
            this.renderNewDate(date);
            dispatcher.publish(LoadEvts.dateChanged, date);
        },
        /**
         * Render new date.
         */
        renderNewDate: function(date) {
            var momentDate = moment(date).format(this.dateFormatString);
            this.currentDate = date; // update the instance's current date

            $(this.targetDivSelector).html(calendarTemplate.render({
                date: momentDate
            }));

            this.createPiker();
        },
        /**
         * Create date piker
         */
        createPiker: function() {
            var calInstance = this;

            // Destroy and remake
            if(this.pickerInstance) {
                this.pickerInstance.destroy();
            }
            this.pickerInstance = new pickadate({
                field: $(this.targetDivSelector)[0],
                trigger: $(this.targetDivSelector + ' .js-clickable-calendar')[0],
                onSelect: function(date) {
                    calInstance.updateDate(date)
                }
            });
        }
    });
 
    return GamedayCalendar;
});

